import React from 'react';
import styles from './SectionCard.module.css';

const SectionCard = ({ title, children, actions }) => (
  <div className={styles.card}>
    <div className={styles.header}>
      <span className={styles.title}>{title}</span>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
    <div className={styles.body}>{children}</div>
  </div>
);

export default SectionCard;
